import { IContextState } from "types/reducers";
import { RequestStatus } from "types/requests";
import { ContextTypeKeys, ContextActionTypes } from "types/context";

const initialState: IContextState = {
  featureFlags: {},
  flagStatus: RequestStatus.NOT_STARTED,
};

export default function context(
  state: IContextState = initialState,
  action: ContextActionTypes
) {
  switch (action.type) {
    case ContextTypeKeys.SET_REQUEST_STATUS:
      return { ...state, flagStatus: action.payload };
    case ContextTypeKeys.RECEIVE_FEATURE_FLAGS:
      return { ...state, featureFlags: action.payload };
    case ContextTypeKeys.UPDATE_FEATURE_FLAG:
      return {
        ...state,
        featureFlags: { ...state.featureFlags, ...action.payload },
      };
    default:
      return state;
  }
}
